"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZES = exports.SKINS = void 0;
var SKINS = {
  standard: 'standard',
  standardFilled: 'standardFilled',
  light: 'light',
  lightFilled: 'lightFilled',
  dark: 'dark',
  transparent: 'transparent'
};
exports.SKINS = SKINS;
var SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
exports.SIZES = SIZES;